import {useState, useEffect, useCallback} from 'react';
import {useSelector} from 'react-redux';
import {
  Button,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Switch,
  FormControlLabel,
} from '@mui/material';
import AttachFilesForm from '@components/AttachFilesForm'

const initData = {
  title: '',
  content: '',
  private: false
};

const FormModal = ({
  boardId,
  data,
  open,
  closeModal,
  completeModal
}) => {
  const {
    boards,
  } = useSelector(store => store.boardAdmin)
  const [isConfirm, setIsConfirm] = useState(false);
  const [form, setForm] = useState(initData);
  const [contentFiles, setContentFiles] = useState([]);

  const onChangeForm = (key, value) => {
    const updatedForm = Object.assign({}, form);
    updatedForm[key] = value;
    setForm(updatedForm);
  };

  const onAddFile = (addedFile) => {
    const tempFiles = [...contentFiles, ...addedFile];
    setContentFiles(tempFiles);
  };

  const onDeleteFile = (deleteIndex) => {
    const tempFiles = contentFiles.filter((_, index) => deleteIndex !== index);
    setContentFiles(tempFiles);
  };

  const onSortFileList = (tempFiles) => {
    setContentFiles(tempFiles);
  };

  const onSaveForm = () => {
    setIsConfirm(true);
    const {title, content, contentId} = form;
    let reqForm = {};
    if (contentId) {
      reqForm ={
        boardId,
        title,
        content,
        isPrivate: form.private,
        boardAttachReqList: contentFiles
          .map((data, index) => Object.assign({}, data, {
            contentId,
            sort: index,
          }))
          .filter(data => data.path)
      }
    } else {
      reqForm ={
        title,
        content,
        private: form.private,
      }
    }
    if (title && content) {
      const contentForm = new FormData();
      contentForm.append('content', JSON.stringify(reqForm));
      let reqContentFiles = contentFiles.filter(file => !file.path);
      reqContentFiles.forEach(file => contentForm.append('contentFiles', file));
      completeModal({boardId, contentId, data: contentForm});
    };
  };

  const getSortList = useCallback((list, key) => {
    const sortList = [...list];
    sortList.sort(function (a, b) {
      if (a[key] > b[key]) {
        return 1;
      }
      if (a[key] < b[key]) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return sortList;
  }, []);

  useEffect(() => {
    if (!data) return;
    setForm(data);
    const sortList = getSortList(data.boardAttachResList, 'sort');
    setContentFiles(sortList);
  }, [data, getSortList]);

  return (
    <Dialog
      open={open}
      onClose={closeModal}
      fullWidth={true}
      maxWidth={'md'}
    >
      <DialogTitle>
        {boards[boardId].name} 게시판 {data?.contentId ? '수정' : '등록'}
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Stack spacing={3}>
          <TextField 
            label="제목" 
            variant="outlined" 
            size="small" 
            autoFocus
            defaultValue={form.title}
            onChange={(e) => onChangeForm('title', e.target.value)}
            required={true}
            error={isConfirm && !form.title}
          />

          <TextField 
            label="내용" 
            variant="outlined" 
            size="small" 
            multiline
            minRows={4}
            maxRows={10}
            defaultValue={form.content}
            onChange={(e) => onChangeForm('content', e.target.value)}
            required={true}
            error={isConfirm && !form.content}
          />

          <FormControlLabel
            control={
              <Switch 
                checked={form.private} 
                color="info" 
                onChange={(e) => onChangeForm('private', e.target.checked)} 
              />
            }
            label="비공개"
          />

          <AttachFilesForm
            title={'첨부파일'}
            files={contentFiles}
            addFile={onAddFile}
            deleteFile={onDeleteFile}
            sortFileList={onSortFileList}
          />
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={onSaveForm} color="info">등록</Button>
        <Button onClick={closeModal}>취소</Button>
      </DialogActions>
    </Dialog>
  );
}

export default FormModal;